// Dependency free on purpose: also imported by vite.config.ts to build the
// language redirect script (see languageRedirectScript.ts).

/** localStorage key of the visitor's chosen language. */
export const LANGUAGE_STORAGE_KEY = "language";

/**
 * The visitor's saved choice, else the browser language (any "pt*" gives pt-PT),
 * else English. languageRedirectScript.ts repeats this rule in plain JavaScript;
 * its test checks both agree.
 */
export function pickLanguage(
  stored: string | null,
  browserLanguages: readonly (string | undefined)[],
): "en" | "pt-PT" {
  if (stored === "en" || stored === "pt-PT") return stored;
  return browserLanguages.some((l) => l?.toLowerCase().startsWith("pt"))
    ? "pt-PT"
    : "en";
}
